import React, { useState } from "react";
import { currentTheme, setTheme } from "../utils/theme";

const Sun = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

const Moon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </svg>
);

// Switches between light and dark; shows what a click switches to
export default function ThemeToggle() {
  const [theme, setState] = useState(currentTheme);
  const next = theme === "dark" ? "light" : "dark";
  const label = next === "dark" ? "Koyu temaya geç" : "Açık temaya geç";

  function toggle() {
    setTheme(next);
    setState(next);
  }

  return (
    <button className="btn btn-ghost theme-toggle" onClick={toggle} title={label} aria-label={label}>
      {next === "dark" ? <Moon /> : <Sun />}
    </button>
  );
}
